import { render } from "./PrintInvoiceMoneyDetailsDesign1.vue?vue&type=template&id=4b7be63a"
import script from "./PrintInvoiceMoneyDetailsDesign1.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceMoneyDetailsDesign1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__